import { AfterContentInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FiltersParams } from './../../models/filters/filters-params.model';
import { PHFiltersController } from './ph-filters.controller';
import { BaseComponent } from '@shared/components/base.component';
import { PhFiltersAction, PhFiltersDataEmitter, PhFiltersService } from './ph-filters.service';
import { FilterContinentComponent } from '@shared/components/ph-filters/components/filter-continent/filter-continent.component';
import { FilterCategoryComponent } from '@shared/components/ph-filters/components/filter-category/filter-category.component';
import { FilterSearchComponent } from '@shared/components/ph-filters/components/filter-search/filter-search.component';
import { SortProjectsComponent } from '@shared/components/ph-filters/components/sort-projects/sort-projects.component';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-ph-filters',
  templateUrl: './ph-filters.component.html',
  styleUrls: ['./ph-filters.component.scss'],
})
export class PhFiltersComponent
  extends BaseComponent
  implements OnInit, AfterContentInit, OnDestroy
{
  showFilters: boolean = false;
  form: UntypedFormGroup = new UntypedFormGroup({});
  phFiltersController: PHFiltersController = null;

  @Input() enabledRanking: boolean = true;
  @Input() isEvent: boolean = false;
  @Input() pathToEnded: string;
  @Input() endedQueryParams: object;
  @Input() searchTitle: string;
  @Input() title: string = '';
  @Input() sorting: string;
  @Input() search: boolean = false;
  @Input() featured: boolean = true;
  @Input() hideFilters: boolean = false;
  @Input() hideBanner: boolean = true;
  @Input() hideFiltersButton: boolean = false;
  @Input() hideEnded: boolean = false;
  @Input() hidePromoted: boolean = false;
  @Input() searchAutoFocus: boolean = false;
  @Input() defaultParams: FiltersParams = null;
  @Input() helpukraine: boolean = false;
  @Input() hideSorting: boolean = false;
  @Input() hideFilterCategory: boolean = false;

  @ViewChild('filterContinent') filterContinent: FilterContinentComponent;
  @ViewChild('filterCategory') filterCategory: FilterCategoryComponent;
  @ViewChild('filterSearch') filterSearch: FilterSearchComponent;
  @ViewChild('sortProjects') sortProjects: SortProjectsComponent;

  constructor(
      public phFiltersService: PhFiltersService,
      public route: ActivatedRoute
  ) {
    super();
  }

  closeAndRemoveFilters() {
    this.showFilters = false;
    this.toggleFiltersBodyClass();
    this.storage.delete('projects-filters');
    this.phFiltersController.someSubscriptions.unsubscribe();
    this.phFiltersController = null;
  }

  ngOnInit() {
    this.phFiltersController = new PHFiltersController(this.phFiltersService, this.form);
    this.toggleFiltersState();
    this.toggleFiltersBodyClass();
    this.defaultParams ? this.phFiltersService.setParams(this.defaultParams) : null;
  }

  ngOnDestroy() {
    this.closeAndRemoveFilters();
  }

  setDefaultParams(params) {
    this.defaultParams = params;
    this.phFiltersService.setParams(this.defaultParams);
    this.phFiltersController.getData();
  }

  ngAfterContentInit() {
    this.phFiltersService.setParams(this.phFiltersService.urlController.readParamsFromUrl());
    this.phFiltersController.getData();
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
    if (this.showFilters) {
      this.storage.put('projects-filters', true);
    } else {
      this.storage.delete('projects-filters');
    }
    this.toggleFiltersBodyClass();
  }

  toggleFiltersBodyClass() {
    if (this.showFilters) {
      document.body.classList.add('ph-filters-open');
    } else {
      document.body.classList.remove('ph-filters-open');
    }
  }

  isRanking() {
    return this.router.url.search('ranking') > 0;
  }
  clearFilters() {
    this.phFiltersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: this.defaultParams,
      })
    );
    this.filterContinent.resetCountry();
    this.filterContinent.resetContinent();
    this.filterCategory.resetCategory();

    if (this.router.url.split('?')[0] === '/projects') {
      this.filterSearch.correctForm.controls['search'].setValue('');
      this.sortProjects.correctForm.controls['order_by'].setValue('newest');
      this.filterCategory.filterFeatured.resetFeatured();
    }
  }

  toggleFiltersState() {
    if (this.storage.get('projects-filters') || this.route.snapshot.queryParams['filters_category'] != null) {
      this.showFilters = true;
    } else {
      this.showFilters = false;
    }
  }
}
